<template>
	<div class="input-group">
		<input
			ref="input"
			v-show="!inline"
			:class="cls"
			:placeholder="placeholder"
			:disabled="disabled"
			class="form-control input-sm"
		/>
		<p v-html="minDate" style="display: none"></p>
		<div class="input-group-addon" @click="limparData" :class="!disabled && 'datetime__clear-button'">
			<i class="fa fa-times" aria-hidden="true"></i>
		</div>
	</div>
</template>

<script>
/*

<flDateTime @v-model="(val) => teste = val"
    :value="form.data_fabricacao"
    time="HH:mm"
    :lang="_getLangDp"
    :format="_formatDate"
    :minDate.sync="minData"
    maxDate="20/07/2017 23:59"
    :disabled="false"
    name="teste" /> <button type="button" @click="minData = '10/07/2017 11:00'">s</button>
    <button type="button" @click="_emit('datetime-clear', 'teste')">l</button>

    */

export default {
	props: {
		cls: {
			required: false
		},

		format: {
			required: true
		},

		inline: {
			type: Boolean,
			required: false,
			default: false
		},

		placeholder: {
			required: false
		},

		especificoDia: {
			required: false,
			type: Array,
			default: () => []
		},

		disabled: {
			required: false,
			default: false
		},

		time: {
			required: false
		},
		lang: {
			required: true
		},
		minDate: {
			required: false
		},

		value: {
			required: false
		},

		maxDate: {
			required: false
		}
	},

	data() {
		return {
			val: '',
			dtRetorno: '',
			min: '',
			max: ''
		}
	},
	methods: {
		limparData: function () {
			if (!this.disabled) this.$emit('v-model', '')
		}
	},
	updated() {
		if (this.minDate !== this.min) {
			window.$(this.$refs.input).data('DateTimePicker').minDate(new window.moment(this.minDate, this.dtRetorno))
		}

		if (this.maxDate !== this.max) {
			window.$(this.$refs.input).data('DateTimePicker').maxDate(new window.moment(this.maxDate, this.dtRetorno))
		}
	},

	mounted() {
		const self = this
		this.dtRetorno = this.format
		////console.log("time", this.lang)
		let lng = 'pt-BR'
		if (this.lang === 'en') {
			lng = 'en-EN'
		}

		if (this.lang === 'es') {
			lng = 'es-ES'
		}

		if (!window._.isNil(this.time) && this.time !== '') {
			this.dtRetorno += ' ' + this.time.trim()
		}

		this.min = this.minDate
		this.max = this.maxDate

		const config = {
			format: this.dtRetorno,
			locale: lng,
			ignoreReadonly: false,
			allowInputToggle: false,
			//disableTouchKeyboard: true,
			// forceParse: true,
			inline: this.inline,
			focusOnShow: false,
			daysOfWeekDisabled: this.especificoDia,
			icons: {
				time: 'fa fa-clock-o',
				date: 'fa fa-calendar',
				up: 'fa fa-chevron-up',
				down: 'fa fa-chevron-down',
				previous: 'fa fa-chevron-left',
				next: 'fa fa-chevron-right',
				today: 'fa fa-screenshot',
				clear: 'fa fa-trash',
				close: 'fa fa-remove'
			}
		}

		if (!window._.isNil(this.minDate) && this.minDate !== '') {
			config.minDate = new window.moment(this.minDate, this.dtRetorno)
		}

		if (!window._.isNil(this.maxDate) && this.maxDate !== '') {
			config.maxDate = new window.moment(this.maxDate, this.dtRetorno)
		}

		window
			.$(this.$refs.input)
			.datetimepicker(config)
			.off('keydown')
			.on('dp.change', function (e) {
				if (e.date) {
					////console.log(e.date.format(self.dtRetorno))
					//self.dt = e.date.format(self.dtRetorno);
					self.$emit('v-model', e.date.format(self.dtRetorno))
				} else {
					self.$emit('v-model', '')
				}
			})

		if (this.value !== '') {
			window.$(self.$refs.input).data('DateTimePicker').date(this.value)
		} else {
			window.$(self.$refs.input).data('DateTimePicker').date(null)
		}
	},

	watch: {
		val(val) {
			this.$emit('v-model', val)
		},

		value(value) {
			if (value === '') {
				window.$(this.$refs.input).data('DateTimePicker').date(null)
			} else {
				window.$(this.$refs.input).data('DateTimePicker').date(value)
			}

			this.$emit('v-model', value)
		},
		// todo: resolver essa sobreescrita de quando o menor ou maior é diferente da data atual
		maxDate(newMaxDate) {
			// problema ao ativar essa propriedade:
			// ele muda automaticamente a data inicial se estiver vazia para a nova data máxima.
			// window.$(this.$refs.input).data('DateTimePicker').maxDate(new window.moment(newMaxDate, this.dtRetorno))
			if (/[0-9]{2}\:[0-9]{2}/.test(newMaxDate)) {
				this.max = newMaxDate
				window.$(this.$refs.input).data('DateTimePicker').maxDate(new window.moment(newMaxDate, this.dtRetorno))
				window.$(this.$refs.input).data('DateTimePicker').date(this.value)
			}
		}
	}
}
</script>

<style>
.datetime__clear-button {
	background-color: white;
}

.datetime__clear-button:hover {
	background-color: #adadad;
	cursor: pointer;
}
</style>